.bar {
  position: absolute;
  right: 0;
  user-select: none;
  z-index: 1;
  display: flex;
  align-items: center;
  margin-right: 8px;
}
